@let commonData = commonDataService.getData() | async;

<ds-card class="p-4 d-flex flex-column card">
  <div class="p-3 icon">
    <img
      src="/assets/icons/account_balance_wallet.svg"
      alt="account_balance_wallet"
      width="24"
      height="24"
    />
  </div>

  <h1 class="semi-bold mt-9" data-id="client-balance">
    {{ clientBalanceAmount | portalCurrency: true }}
  </h1>

  <div (click)="showModal(modalTemplate)" class="d-flex align-items-center mt-1 cursor-pointer">
    <p>{{ commonData?.label }} credits</p>

    <img
      src="assets/icons/info_outlined.svg"
      width="16"
      height="16"
      alt="info_outlined"
      class="ml-1"
      data-id="details"
    />
  </div>
</ds-card>

<ng-template #modalTemplate>
  <div class="d-flex flex-column m-4 m-md-8">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="semi-bold">{{ commonData?.label }} Credits</h2>

      <ds-button
        (click)="hideModal()"
        variant="icon"
        size="s"
        icon="xmark"
        label="Close"
        class="d-none d-md-inline"
        data-id="hide"
      />
    </div>

    <h1 class="semi-bold mt-4" data-id="client-balance">
      {{ clientBalanceAmount | portalCurrency: true }}
    </h1>

    @if (creditBreakdown.length) {
      <div class="d-flex flex-column mt-4">
        <div class="d-flex justify-content-between align-items-center">
          <p class="caption semi-bold">Credits</p>
          <p class="caption semi-bold">Expiry Date</p>
        </div>

        @for (breakdown of creditBreakdown; track breakdown; let last = $last) {
          <div class="d-flex justify-content-between align-items-center my-3">
            <p data-id="amount">{{ breakdown.remainingAmount | portalCurrency }}</p>
            <p data-id="expires-at">{{ breakdown.expiresAt | date: 'MMM d, yyyy' }}</p>
          </div>

          @if (!last) {
            <hr />
          }
        }
      </div>
    }

    <p class="mt-4">
      Use on any eligible trip, for any passenger. Combine with a card if needed; unused balance
      remains. Not redeemable for cash.
    </p>

    <p class="mt-2">
      Credits expire 12 months from the ticket purchase date. We will send you timely reminders on
      your registered email.
    </p>
  </div>
</ng-template>
